const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const HUMAN_DATE = /^\d{1,2} [A-Za-z]+ \d{4}$/;

export function toIso(now = Date.now()) {
  return new Date(now).toISOString();
}

export function stampCreated(meta = {}, now = Date.now()) {
  if (meta.date_created) return meta;
  return { ...meta, date_created: toIso(now) };
}

export function stampModified(meta = {}, now = Date.now()) {
  return { ...meta, last_modified: toIso(now) };
}

/** Persist created if missing, and always refresh last modified (save). */
export function stampSaved(meta = {}, now = Date.now()) {
  return stampModified(stampCreated(meta, now), now);
}

/** Opened-file modified comes from the File object, not a typed field. */
export function metaFromOpenedFile(meta = {}, file) {
  const next = { ...meta };
  if (file && Number.isFinite(file.lastModified)) {
    next.last_modified = toIso(file.lastModified);
  }
  return next;
}

export function formatMetaDate(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'string' && HUMAN_DATE.test(value.trim())) return value.trim();
  const date = typeof value === 'number' && Number.isFinite(value)
    ? new Date(value)
    : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const datePart = `${date.getDate()} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${datePart}, ${hours}:${minutes}`;
}
